import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { selfRegistrationPageQueryOptions } from "~/app/api/pageData/selfRegistrationPageQuery";
import type { SelfRegistrationPageInitialData } from "~/app/api/pageData/selfRegistrationPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createCustomerRegistrationPage } from "~/features/registration/components/CustomerRegistrationPage/CustomerRegistrationPage";

function toRegistrationProps(data: SelfRegistrationPageInitialData | undefined) {
  return {
    countries: data?.countryIsocodes ?? [],
    currencies: data?.currencyIsocodes ?? [],
    sectors: data?.sectors ?? {},
    jobTitles: data?.jobTitles ?? {},
  };
}

function SelfRegistrationRoute() {
  const result = useLoaderData({
    from: "/become-schaeffler-customer",
  }) as PageInitialData<SelfRegistrationPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createCustomerRegistrationPage(toRegistrationProps(result.data))}
    </StorefrontShellFrame>
  );
}

export async function loadSelfRegistrationPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(selfRegistrationPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const selfRegistrationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/become-schaeffler-customer",
  loader: async ({ context }) => loadSelfRegistrationPageData(context),
  component: SelfRegistrationRoute,
});
